import { FC, useRef, useState } from 'react';

import { DataProvider, Input, StaticDataFetcherItem, Suggest } from '@hh.ru/magritte-ui';
import { BarsOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useProfRolesTranslations, { TranslationNamespaces } from 'hooks/translation/useProfRolesTranslations';
import useTrls from 'hooks/translation/useTrls';

import { useCompositeSelectionContext } from 'components/common/CompositeSelection/contexts';

export const AdProfessionsInput: FC<{ provider: DataProvider<StaticDataFetcherItem> }> = ({ provider }) => {
    const suggestRef = useRef<HTMLDivElement>(null);
    const { setTreeSelectorModalVisibility, collection, value, onChange } = useCompositeSelectionContext();

    const translations = useProfRolesTranslations(TranslationNamespaces.AdCreate);
    const trl = useTrls();

    const [inputValue, setInputValue] = useState('');

    const handleOpenModal = () => {
        setTreeSelectorModalVisibility(true);
    };

    const handleChange = (selectedValue: string, isValueFromList: boolean) => {
        if (isValueFromList) {
            suggestRef.current?.blur();
            return;
        }
        setInputValue(selectedValue);
    };

    const handleSelect = (selectedValue: string) => {
        if (!value.includes(selectedValue)) {
            const foundItem = collection.toList().find((item) => item.id === selectedValue);
            if (foundItem) {
                onChange((prev) => ({ ...prev, value: [...value, foundItem.id] }));
                setInputValue('');
                return true;
            }
        }
        return false;
    };

    return (
        <Suggest
            ref={suggestRef}
            dataProvider={provider}
            inputValue={inputValue}
            headerTitle={trl(translations.title)}
            errorPlaceholder={trl(translations.searchPlaceholderMagritte)}
            trls={{
                resetButton: trl(translations.resetButton),
            }}
            onSelectValidator={handleSelect}
            onChange={handleChange}
            input={{
                component: Input,
                props: {
                    size: 'medium',
                    placeholder: trl(translations.searchPlaceholderMagritte),
                    buttonIcon: BarsOutlinedSize24,
                    onButtonClick: handleOpenModal,
                    'data-qa': 'profession-targeting-input',
                },
            }}
        />
    );
};
